import React from "react";
import { Text, IconButton, HStack } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { MonthSelectorState } from "../../models/Consultant";

interface Props {
	handlePrevMonth: () => void;
	handleNextMonth: () => void;
	value: MonthSelectorState;
	condensed?: boolean;
}

const MonthSelector = ({ handlePrevMonth, handleNextMonth, value, condensed = false }: Props) => {
	const formatMonthText = () => {
		if (condensed) {
			// Show first 3 chars of month + year (e.g., "nov 2025")
			const monthShort = value.startDate.toLocaleString("sv-SE", { month: "long" }).substring(0, 3);
			const year = value.startDate.toLocaleString("sv-SE", { year: "numeric" });
			return `${monthShort} ${year}`;
		}
		// Full format (e.g., "november 2025")
		return value.startDate.toLocaleString("sv-SE", { month: "long", year: "numeric" });
	};

	return (
		<HStack
			justifyContent={"center"}
			borderRight={"1px solid #DEDEDE"}
			borderBottom={"1px solid #DEDEDE"}
			bg={"#FFFFFF"}
			p={2}
			borderRadius={"8px"}
			maxW={condensed ? "150px" : "200px"}
		>
			<IconButton
				size={"xs"}
				isRound
				onClick={handlePrevMonth}
				aria-label="previous month"
				icon={<ChevronLeftIcon />}
			/>
			<Text
				width={condensed ? "90px" : "140px"}
				textAlign={"center"}
				fontSize={"14px"}
				fontWeight={600}
				textTransform={"capitalize"}
			>
				{formatMonthText()}
			</Text>
			<IconButton
				size={"xs"}
				isRound
				onClick={handleNextMonth}
				aria-label="next month"
				icon={<ChevronRightIcon />}
			/>
		</HStack>
	);
};

export default MonthSelector;
